<!--
 * @Author: “周晓清“ “zhouxq@yxt.com”
 * @Date: 2021-08-31 10:16:11
 * @LastEditors: “周晓清“ “zhouxq@yxt.com”
 * @LastEditTime: 2022-07-14 11:00:06
 * @FilePath: \yxt-biz-pc\packages\teacher-selector\src\main.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yxtbiz-teacher-selector" :class="{'yxtbiz-teacher-selector-padding': showPadding}">
    <yxt-tabs
      v-if="setTabs.length > 1"
      @tab-click="tabClick"
      v-model="activeName"
    >
      <yxt-tab-pane
        :key="index"
        v-for="(tab, index) in setTabs"
        :name="tab.value"
      >
        <span slot="label">{{ tab.label }}</span>
      </yxt-tab-pane>
    </yxt-tabs>
    <!-- 选择人员 -->
    <yxtbiz-range-selector
      v-if="isSelectUser"
      ref="rangeSelector"
      :class="setTabs.length > 1 ? 'yxtbiz-teacher-selector__pt10' : ''"
      v-model="users"
      :multiple="!singleMode"
      :model="'array'"
      :limit="singleMode ? 0 : limit"
      :functionCode="functionCode"
      :dataPermissionCode="selectUserPermissionCode"
      :tabs="['persons']"
      @change="changeFn"
    ></yxtbiz-range-selector>
    <div v-if="!isSelectUser" :class="setTabs.length > 1 ? 'yxtbiz-teacher-selector__pt10' : ''" class="yxtbiz-teacher-selector__range">
        <div class="yxtbiz-teacher-selector__range-main">
          <div class="yxtbiz-teacher-selector__range-main-content" :class="isHideRight ? 'yxtbiz-teacher-pr24' : ''">
            <div class="yxtbiz-teacher-selector__container yxt-teacher-multi-container">
              <div class="yxtbiz-teacher-search-wrap">
                <!-- <div class="yxtbiz-teacher-container__flex"> -->
                <yxtbiz-group-org-select
                  v-if="selectOrg && this.activeName !== 'giveLesson'"
                  class="mr12 yxtbiz-teacher-search-inlineb mb16"
                  size="small"
                  setCurrentOrg
                  :disabledOrgIds="disabledOrgIds"
                  :selectFirst="true"
                  :clearable="false"
                  :multiple="false"
                  :functionCode="functionCode"
                  :dataPermissionCode="dataPermissionCode"
                  @change="changeOrg"
                ></yxtbiz-group-org-select>
                <yxt-select
                  v-if="type === -1 && this.activeName !== 'giveLesson'"
                  v-model="teType"
                  class="mr12 yxtbiz-teacher-search-inlineb mb16"
                  size="small"
                  :placeholder="$t('pc_biz_te_tip_teachertype')"
                  style="width: 144px"
                  @change="getTeList(true)"
                >
                  <yxt-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></yxt-option>
                </yxt-select>
                <select-popover
                  v-if="teType !== '1'"
                  class="mr12 yxtbiz-teacher-search-inlineb mb16"
                  size="small"
                  :style="{ width: this.activeName !== 'giveLesson' ? '144px' : '180px' }"
                  ref="selectPopover"
                  is-dept
                  :selectOpition="selectOpition"
                >
                  <dept-tree
                    :functionCode="functionCode"
                    :dataPermissionCode="dataPermissionCode"
                    :filterable="true"
                    :visibleOrgSelector="false"
                    :targetOrgId="teSearch.targetOrgId"
                    :enableGroupCorp="selectOrg"
                    @nodeClick="nodeClick"
                  ></dept-tree>
                </select-popover>
                <yxt-select
                  v-if="this.activeName !== 'giveLesson'"
                  v-model="levelVal"
                  size="small"
                  class="mr12 yxtbiz-teacher-search-inlineb mb16"
                  style="width: 144px"
                  clearable
                  :placeholder="$t('pc_biz_te_selete_level')"
                  @change="changeLevel"
                >
                  <yxt-option
                    v-for="item in levelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </yxt-select>
                <yxt-select
                  v-if="isShowTeStatus"
                  v-model="teStatusVal"
                  size="small"
                  class="mr12 yxtbiz-teacher-search-inlineb mb16"
                  style="width: 144px"
                  clearable
                  :placeholder="$t('pc_biz_te_status')"
                  @change="changeLevel"
                >
                  <yxt-option
                    v-for="item in teStatuslList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </yxt-select>
                <yxt-input
                  :style="{ width: this.activeName !== 'giveLesson' ? '178px' : '220px' }"
                  :placeholder="teType === '1' ? $t('pc_biz_te_tip_enternamesearch') : $t('pc_biz_te_tip_enternameaccountsearch')"
                  class="yxtbiz-teacher-search-inlineb mb16"
                  v-model="teSearch.keyword"
                  searchable
                  size="small"
                  maxlength="50"
                  @search="teNameSearch"
                >
                </yxt-input>
                <!-- </div> -->
              </div>
                <yxt-table
                  ref="stb"
                  class="yxt-teacher-table pr20"
                  @select-all="selectAll"
                  @select="select"
                  v-loading="loading"
                  :key="`t${renderCount}`"
                  :data="teaList"
                  :height="tableHeight"
                >
                  <yxt-table-column
                    v-if="!isSingle"
                    :show-overflow-tooltip="false"
                    class-name="yxtbiz-table-selection"
                    type="selection"
                    width="40"
                  ></yxt-table-column>
                  <yxt-table-column
                    v-else
                    :show-overflow-tooltip="false"
                    class-name="yxtbiz-table-selection"
                    width="40"
                  >
                    <template slot-scope="scope">
                      <yxt-radio v-model="singleSelect" @change="selectTea(scope.row)" :label="scope.row.id"></yxt-radio>
                    </template>
                  </yxt-table-column>
                  <yxt-table-column
                    width="18"
                    align="right"
                    clear-padding="left-right"
                    v-if="!isSingle"
                    >
                    <template slot="header">
                      <yxt-dropdown placement="bottom-start" @command="tableHeaderCommand">
                          <span> </span>
                          <yxt-dropdown-menu slot="dropdown">
                            <yxt-dropdown-item command="selectCurrentData">{{$t('pc_biz_te_select_current_page').d('选择本页')}}</yxt-dropdown-item>
                            <yxt-dropdown-item command="selectAllData" >{{$t('pc_biz_te_select_all').d('选择全部')}}</yxt-dropdown-item>
                            <yxt-dropdown-item command="clearSelectData" >{{$t('pc_biz_te_clear_all').d('清空所选')}}</yxt-dropdown-item>
                          </yxt-dropdown-menu>
                      </yxt-dropdown>
                    </template>
                  </yxt-table-column>
                  <yxt-table-column
                    :label="teType === '1' ? $t('pc_biz_te_lbl_teachername') : $t('pc_biz_te_lbl_teachernameaccount')"
                    :show-overflow-tooltip="false"
                  >
                    <template slot-scope="scope">
                      <div class="yxtbiz-teacher-flex-center">
                        <yxt-tooltip effect="dark" placement="top" :open-filter="true">
                          <div slot="content">
                            <span
                              ><yxtbiz-user-name :name="scope.row.fullname" />{{
                                scope.row.type === 0 || teType !== '1' ? `（${scope.row.username}）` : ''
                              }}</span
                            >
                          </div>
                          <div class="ellipsis nowrap">
                            <span
                              ><yxtbiz-user-name :name="scope.row.fullname" />{{
                                scope.row.type === 0 || teType !== '1' ? `（${scope.row.username}）` : ''
                              }}</span
                            >
                          </div>
                        </yxt-tooltip>
                        <yxt-tag v-if="scope.row.share" size="mini" class="ml4">{{
                          $t('pc_biz_te_lbl_group_share' /* 共享 */)
                        }}</yxt-tag>
                      </div>
                    </template>
                  </yxt-table-column>
                  <yxt-table-column
                    v-if="teType !== '1'"
                    show-overflow-tooltip
                    popover-html
                    :label="$t('pc_biz_te_lbl_department')"
                    prop="departmentName"
                    align="left"
                  >
                    <template slot-scope="scope">
                      <yxtbiz-dept-name
                        :name="scope.row.departmentName || '--'"
                      /> </template
                  ></yxt-table-column>
                  <yxt-table-column
                    show-overflow-tooltip
                    :label="$t('pc_biz_te_lbl_level')"
                    prop="levelName"
                    align="left"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.levelName || '--' }}
                    </template>
                  </yxt-table-column>
                  <yxt-table-column
                    v-if="isShowTeStatus"
                    show-overflow-tooltip
                    :label="$t('pc_biz_tcm_testatus')"
                    prop="disabled"
                    align="left"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.disabled ? $t('pc_biz_te_disable') : $t('pc_biz_te_enable') }}
                    </template>
                  </yxt-table-column>
                  <template slot="empty">
                    <div style="line-height: normal">
                      <yxt-empty
                        :empty-text="
                          activeName === 'certifiedLecturer'
                            ? $t(
                                'pc_biz_te_no_certification_lecturer' /*暂无认证讲师，您可以在讲师库选择其他讲师*/
                              )
                            : $t('pc_biz_lbl_nodata' /*暂无数据*/)
                        "
                      />
                    </div>
                  </template>
                </yxt-table>
              <div class="yxtbiz-teacher-selector__mask mt16 pr20">
                <yxt-pagination
                  class="pull-right"
                  :page-size="teSearch.limit"
                  :total="count"
                  :current-page="page"
                  layout="total, prev, pager, next"
                  @current-change="pageChange"
                  @size-change="sizeChange"
                ></yxt-pagination>
              </div>
            </div>
          </div>
          <div v-if="!isHideRight" class="yxtbiz-teacher-selector__checkedlist">
            <!-- <CheckedList limit={this.limit} checkedData={this.selectData} tabs={this.tabs} enableGroupCorp={this.enableGroupCorp} onChange={this.selectedChange} /> -->
            <check-list :limit="limit" :checkedData="teDataUser" @change="selectedChange" />
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {
  // getTeList,
  GetTeChooseType,
  getTeLevelList,
  getGroupTeLevelList,
  // getOfflineTeList,
  getRptTeList
} from './service';
import resizeTable from '../../user-selector/mixins/resizeTable';
import UserName from 'yxt-biz-pc/packages/user-name';
import DeptName from 'yxt-biz-pc/packages/dept-name';
import { Table, TableColumn, Pagination, Link, Select, Option } from 'yxt-pc';
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
import SelectPopover from '../../check-person-range/src/components/SelectPopover.vue';
import deptTree from '../../dept-tree';
import CheckList from './components/checkList.vue';
// import de from 'yxt-biz-pc/src/locale/lang/de';

export default {
  name: 'YxtbizTeacherSelectorV2',
  name_zh: '讲师组件选择V2',
  eventList: [
    {
      type: 'select', // 抛出的事件名
      handler: 'onChange', // 事件处理函数
      label: '点击选择后的事件' // 事件描述
    },
    {
      type: 'input', // 抛出的事件名
      handler: 'onChange', // 事件处理函数
      label: '点击选择后的事件' // 事件描述
    }
  ],
  components: {
    YxtbizUserName: UserName,
    YxtbizDeptName: DeptName,
    YxtTable: Table,
    YxtTableColumn: TableColumn,
    YxtPagination: Pagination,
    YxtLink: Link,
    YxtSelect: Select,
    YxtOption: Option,
    SelectPopover,
    deptTree,
    CheckList
  },
  mixins: [resizeTable],
  props: {
    // 是否显示讲师状态
    isShowTeStatus: {
      type: Boolean,
      default: false,
      desc: '是否显示讲师状态',
      setter: 'BooleanSetter'
    },
    value: {
      type: Array | Object,
      default: () => {
        return {};
      },
      desc: '当前选择的对象',
      setter: 'JsonSetter'
    },
    type: {
      type: Number,
      default: -1,
      desc: '讲师类型',
      setter: 'NumberSetter'
    },
    // 是否显示授课员工
    allowSelectTeachUser: {
      type: Boolean,
      default: false,
      desc: '是否显示授课员工',
      setter: 'BooleanSetter'
    },
    // 是否可以有选人模式
    allowSelectUser: {
      type: Boolean,
      default: false,
      desc: '是否可以有选人模式',
      setter: 'BooleanSetter'
    },
    // 是否强制单选模式， 默认会根据传入的数据类型修改。true时强制单选模式
    singleMode: {
      type: Boolean,
      default: false,
      desc: '是否强制单选模式',
      setter: 'BooleanSetter'
    },
    functionCode: {
      type: String,
      default: '',
      desc: '页面的导航编号',
      setter: 'StringSetter'
    },
    // // 是否切换到新组件模式 0-否 1-是 控制禁用/删除/预备的讲师是否显示，1为新组件模式，不显示
    // newReq: {
    //   type: Boolean,
    //   default: false
    // },
    // 是否显示预备讲师(默认不显示预备) 0-否 1-是 （预备讲师显示的控制优先级高于newReq）
    prepared: {
      type: Boolean,
      default: false,
      desc: '是否显示预备讲师',
      setter: 'BooleanSetter'
    },
    dataPermissionCode: {
      type: String,
      default: '',
      desc: '选导师的数据权限点',
      setter: 'StringSetter'
    },
    selectUserPermissionCode: {
      type: String,
      default: '',
      desc: '选人的数据权限点',
      setter: 'StringSetter'
    },
    // 课程id，如果有值则显示认证讲师tab
    courseId: {
      type: String,
      default: '',
      desc: '面授课程id',
      setter: 'StringSetter'
    },
    // 讲师（只有内部讲师）关联UDP用户状态过滤标记位 UDP用户状态 0禁用 1启用 -1：不过滤 默认启用
    udpUserStatus: {
      type: Number,
      default: 1,
      desc: '讲师（只有内部讲师）关联UDP用户状态过滤标记位',
      setter: 'NumberSetter'
    },
    // // 是否2.0报表组件请求 0-否 1-是
    // showAll: {
    //   type: Boolean,
    //   default: false
    // },
    // 是否支持跨机构选择（集团版）
    selectOrg: {
      type: Boolean,
      default: false,
      desc: '是否支持跨机构选择（集团版）',
      setter: 'BooleanSetter'
    },
    // // 针对预约讲师需求
    // showSubscribeStatus: {
    //   type: Boolean,
    //   default: false
    // },
    // subscribeStartTime: {
    //   type: String,
    //   default: ''
    // },
    // subscribeEndTime: {
    //   type: String,
    //   default: ''
    // },
    needPadding: {
      type: Boolean,
      default: false,
      desc: '是否增加padding',
      setter: 'BooleanSetter'
    },
    maxLimit: {
      type: Number,
      default: 0,
      desc: '最大数量',
      setter: 'NumberSetter'
    },
    // 返回讲师ID的取值类型  0：取te_teacher表主键作为ID返回   1：取te_teacher表user_id字段作为ID返回  null或者其他：参照1
    idType: {
      type: Number,
      default: 1,
      desc: '返回讲师ID的取值类型',
      setter: 'NumberSetter'
    },
    isHideRight: {
      type: Boolean,
      default: false,
      desc: '是否隐藏右侧',
      setter: 'BooleanSetter'
    }
  },
  data() {
    return {
      teDataUser: [],
      singleSelect: '',
      limit: this.maxLimit,
      teStatusVal: '',
      teStatuslList: [
        {
          value: 0,
          label: this.$t('pc_biz_te_enable') // 启用
        },
        {
          value: 1,
          label: this.$t('pc_biz_te_disable') // 禁用
        }
      ],
      renderCount: 0,
      page: 1,
      refTable: 'stb',
      tableHeight: 0,
      teSearch: {
        type: -1,
        keyword: '',
        limit: 20,
        offset: 0,
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode,
        deptId: '', // 部门id
        levelId: '' // 级别id
      },
      loaded: 1,
      loading: false,
      totalPage: 0,
      count: 0,
      teaList: [],
      teType: '0',
      options: [
        {
          value: '0',
          label: this.$t('pc_biz_te_lbl_internallecturer') // 内部讲师
        },
        {
          value: '1',
          label: this.$t('pc_biz_te_lbl_externallecturer') // 外部讲师
        }
      ],
      selected: {},
      user: {},
      users: [],
      isSingle: true, // m2只有单选模式
      isSingleVal: true,
      isCanSelectUser: false,
      isSelectUser: false,
      setTabs: [
        {
          label: this.$t('biz_te_official_teach'), // 正式讲师
          value: 'teacher'
        }
      ],
      activeName: this.courseId ? 'certifiedLecturer' : 'teacher',
      teSelected: [],
      teData: [],
      firstFlag: false,
      selectOpition: {
        placeholder: i18n.t('pc_biz_te_dept' /* 选择部门 */),
        checkWord: ''
      },
      levelList: [], // 级别列表
      levelVal: '',
      query: {
        showNoClassification: '',
        orgId: ''
      }
    };
  },
  computed: {
    tabType() {
      switch (this.activeName) {
        case 'teacher':
          return 0;
        case 'giveLesson':
          return 1;
        case 'certifiedLecturer':
          return 2;
        default:
          return 0;
      }
    },
    // 开启集团且弱管理
    noStrong() {
      return (
        window.localStorage.getItem('enableGroupCorp') === 'true' &&
        window.localStorage.getItem('manageMode') === '1'
      );
    },
    // 集团服务下的级别接口
    groupLevel() {
      return this.selectOrg;
    },
    // 针对o2o选择讲师是否可选人员配置（/te/externalfacade/o2o/choose/type）
    // 根据needpadding对无tab样式做特殊处理
    showPadding() {
      return this.needPadding && this.setTabs.length < 2;
    }
  },
  created() {
    this.isSingleVal =
      !this.value || (!this.value.length && this.value.length !== 0);
    this.isSingle = this.singleMode || this.isSingleVal;
    this.teData = this.value || [];
    if (Object.prototype.toString.call(this.value) === '[object Object]') {
      if (this.value.id) {
        this.teData = [this.value];
        this.singleSelect = this.value.id;
      } else {
        this.teData = [];
      }
    }
    // if (this.singleMode) {
    //   this.user = this.teData[0] || {};
    // }
    this.formatModel(this.value);
    this.initChooseType();
    !this.selectOrg && this.getTeList();
    !this.selectOrg && this.getLevelList();
  },
  methods: {
    async validate() {
      if (this.isSelectUser) {
        const status = await this.$refs.rangeSelector.validate();
        return status;
      } else {
        if (this.limit && this.teDataUser && this.teDataUser.length > this.limit) {
          this.$alert(
            this.$t('pc_biz_select_msg_limit').d('已选数量超过限制，请检查'),
            this.$t('biz_tcm_limitnum', { x: this.limit }),
            {
              confirmButtonText: this.$t('biz_tcm_checkbtn'),
              type: 'error'
            }
          );
          return false;
        } else {
          return true;
        }
      }
    },
    selectedChange(deleteInfo) {
      this.singleSelect = '';
      if (deleteInfo.type === 'all') {
        this.clearSelectData();
      } else {
        this.deleteItem(deleteInfo.deleteItem);
      }
      // this.deleteItem(deleteItem);
    },
    tableHeaderCommand(row) {
      this[row]();
    },
    selectCurrentData() {
      // 选择本页
      this.teaList.forEach(obj => {
        this.selected[obj.id] = obj;
      });
      this.outPut();
    },
    async selectAllData() {
      // 选择所有
      this.LoadAll();
    },
    clearSelectData() {
      this.$refs['stb'].clearSelection();
      this.selected = [];
      this.teData = [];
      this.outPut();
    },
    async LoadAll() {
      this.getParams(true);
      this.loading = true;
      // let teApi =
      //   this.activeName === 'certifiedLecturer' ? getOfflineTeList : getTeList;
      let teApi = getRptTeList;
      this.loading = true;
      const limit = 1000;
      const reqCount = Math.ceil(this.count / limit); // 循环次数
      const reqArrs = []; // 请求数组
      for (let i = 0; i < reqCount; i++) {
        const params = Object.assign({}, this.teSearch, {
          limit: limit,
          offset: limit * i
        });
        reqArrs.push(params);
      }
      try {
        const results = await Promise.all(
          reqArrs.map(params => teApi(params, this.enableGroupCorp))
        );
        const dataSource = [];
        results.forEach(res => {
          dataSource.push(...res.datas);
        });
        console.log(dataSource);
        // this.teaList = dataSource;
        dataSource.forEach(obj => {
          this.selected[obj.id] = obj;
        });
        this.outPut();
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    getParams(isReset) {
      if (isReset) {
        this.page = 1;
        this.teSearch.offset = 0;
      }
      this.teSearch.teType = this.type === -1 ? this.teType || -1 : this.teType;
      // this.newReq && (this.teSearch.newReq = 1);
      !this.prepared && (this.teSearch.prepared = 0);
      this.teSearch.keyword = this.teSearch.keyword.trim();
      // this.teSearch.rptReq = this.showAll ? 1 : 0;
      // (this.selectOrg) &&
      //   (this.teSearch.groupReq = 1); // 是否是集团请求 0-否 1-是
      // this.selectOrg && (this.teSearch.selectOrg = 1); // 是否需要跨平台显示讲师（集团化适用）0-否 1-是
      if (this.activeName === 'certifiedLecturer' || this.courseId) {
        this.teSearch.courseId = this.courseId;
      }
      // 是否查询有讲师授课数据的员工 0-否 1-是
      // this.teSearch.selectEmp = this.activeName === 'giveLesson' ? 1 : 0;
      // // 预约讲师接收预约时段参数
      // if (this.showSubscribeStatus) {
      //   this.teSearch.apptStartDate = this.subscribeStartTime || '';
      //   this.teSearch.apptEndDate = this.subscribeEndTime || '';
      // }
      if (this.teSearch.teType === '1') {
        this.teSearch.deptId = '';
      }
      if (this.activeName !== 'certifiedLecturer' && this.teSearch.deptId) {
        this.teSearch.deptInclude = 1;
      } else {
        delete this.teSearch.deptInclude;
      }
      if (this.isShowTeStatus) {
        // this.teSearch.disabled = this.teStatusVal || this.teStatusVal === 0 ? this.teStatusVal : 1;
        this.teSearch.disabled = this.teStatusVal;
      }
      this.teSearch.tabType = this.tabType;
      if (this.udpUserStatus === -1) {
        delete this.teSearch.udpUserStatus;
      } else {
        this.teSearch.udpUserStatus = this.udpUserStatus;
      }
      if (this.idType === 0) {
        this.teSearch.idType = this.idType;
      }
      // if (this.activeName !== 'certifiedLecturer') {
      //   this.teSearch.udpUserStatus = 1;
      // } else {
      //   delete this.teSearch.udpUserStatus;
      // }
    },
    // 列表数据
    getTeList(isReset) {
      this.getParams(isReset);
      this.loading = true;
      // let teApi =
      //   this.activeName === 'certifiedLecturer' ? getOfflineTeList : getTeList;
      let teApi = getRptTeList;
      teApi(this.teSearch)
        .then(result => {
          this.teaList = result.datas;
          this.totalPage = result.paging.pages;
          this.count = result.paging.count;
          this.loaded--;
          this.loading = false;
          this.$nextTick(() => {
            this.setChecked();
          });
        })
        .catch(e => {
          this.loading = false;
          console.log(e);
        });
    },
    // 多选是否显示tab
    initChooseType() {
      GetTeChooseType()
        .then(result => {
          if (this.allowSelectTeachUser) {
            this.setTabs = [
              ...this.setTabs,
              {
                label: this.$t('biz_te_give_lesson_user'), // 授课员工
                value: 'giveLesson'
              }
            ];
          }
          this.isCanSelectUser = this.allowSelectUser && result.pattern === 0;
          if (this.isCanSelectUser) {
            this.setTabs = [
              ...this.setTabs,
              {
                label: this.$t('biz_te_user'), // 员工
                value: 'person'
              }
            ];
          }
          if (this.courseId) {
            this.setTabs.unshift({
              label: this.$t('pc_te_lbl_certified_lecture'), // 认证讲师
              value: 'certifiedLecturer'
            });
            this.activeName = 'certifiedLecturer';
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    teNameSearch() {
      this.teSearch.searchKey = this.teCatalogSearch;
      this.getTeList(true);
    },
    sizeChange(size) {
      this.teSearch.limit = size;
      this.getTeList(true);
    },
    pageChange(page) {
      this.page = page;
      this.teSearch.offset = (page - 1) * this.teSearch.limit;
      this.getTeList();
    },
    selectTea(item) {
      if (this.isSingleVal) {
        if (this.value && this.value.id) {
          if (item) {
            if (item.id === this.value.id) {
              this.$emit('input', null);
              this.$emit('select', null);
              this.teData = null;
            } else {
              this.$emit('input', item);
              this.$emit('select', item);
              // this.teData = [item];
              this.teData = item;
              this.singleSelect = item.id;
            }
          } else {
            this.$emit('input', this.value);
            this.$emit('select', this.value);
            // this.teData = [this.value];
            this.teData = this.value;
            this.singleSelect = this.value.id;
          }
        } else {
          if (item) {
            this.$emit('input', item);
            this.$emit('select', item);
            // this.teData = [item];
            this.teData = item;
            this.singleSelect = item.id;
          } else {
            this.$emit('input', null);
            this.$emit('select', null);
            this.teData = null;
          }
        }
      } else {
        // 兼容之前的多选模式的数组型数据源&& 不是选人场景不可以反选选人的值
        if (item) {
          // 判断是否取消
          if (this.value.length && this.value[0].id === item.id) {
            this.$emit('input', []);
            this.$emit('select', []);
            this.teData = [];
          } else {
            this.$emit('input', item ? [item] : []);
            this.$emit('select', item ? [item] : []);
            this.teData = item ? [item] : [];
          }
        } else {
          this.$emit('input', []);
          this.$emit('select', []);
          this.teData = [];
        }
      }
    },
    selectUser() {
      if (this.user && this.user.id) {
        this.selectTea({
          id: this.user.id,
          fullname: this.user.fullname,
          isUser: true
        });
      } else {
        if (this.teData.length) {
          this.selectTea(this.teData[0]);
        } else {
          this.selectTea();
        }
      }
    },
    deleteItem(item) {
      // console.log(item);
      delete this.selected[item.id];
      this.outPut();
      // this.selectTea(item);
    },
    // 选择某个
    select(item, row) {
      let isAdd = item.some(v => {
        return v.id === row.id;
      });
      if (!isAdd) {
        delete this.selected[row.id];
      } else {
        this.selected[row.id] = row;
      }
      this.outPut();
    },
    // 全选
    selectAll(items) {
      let isAdd = items.length !== 0; // 判断 items 是否有元素
      this.teaList.forEach(obj => {
        if (!isAdd) {
          delete this.selected[obj.id];
        } else {
          this.selected[obj.id] = obj;
        }
      });
      this.outPut();
    },
    outPut() {
      this.teSelected = Object.values(this.selected);
      let reArry = this.reduceFn([...this.teSelected]);
      if (this.isSingleVal && reArry.length === 0) {
        reArry = null;
      }
      this.$emit('input', reArry);
      this.$emit('select', reArry);
      this.teData = reArry;
    },
    setChecked() {
      if (this.isSelectUser) {
        return;
      }
      this.teaList.forEach(obj => {
        if (this.selected.hasOwnProperty(obj.id)) {
          this.$refs['stb'].toggleRowSelection(obj, true);
          this.singleSelect = obj.id;
        } else {
          this.$refs['stb'] && this.$refs['stb'].toggleRowSelection(obj, false);
        }
      });
    },
    formatModel(v) {
      this.selected = {};
      if (v) {
        if (this.isSingle) {
          // 单选入参v也存在array类型
          if (Object.prototype.toString.call(v) === '[object Object]') {
            if (v.id) {
              this.selected[v.id] = v;
            }
          } else {
            v.forEach(obj => {
              this.selected[obj.id] = obj;
            });
          }
        } else {
          v.forEach(obj => {
            this.selected[obj.id] = obj;
          });
        }
      }
    },
    // tab切换后重新勾选上已选择的讲师
    tabClick() {
      this.singleSelect = '';
      this.teStatusVal = '';
      this.selectOpition.checkWord = '';
      this.teSearch.deptId = ''; // 清空部门选项
      this.teType = this.type === -1 ? '0' : this.type; // 清除讲师已选类型
      this.levelVal = ''; // 清除已选讲师等级
      this.teSearch.levelId = '';
      this.teSearch.keyword = '';
      if (this.activeName !== 'person') this.getTeList();
      this.isSelectUser = this.activeName === 'person';
      this.firstFlag = true;
      if (this.teData && this.teData.length > 0) {
        this.users = this.teData;
        // 切换到选人tab后，数据不一致清空user
        if (this.isSelectUser && this.user && this.user.id && this.teData[0].id !== this.user.id) {
          this.user = {};
        }
      } else {
        this.users = [];
        this.user = {};
      }
      this.formatModel(this.teData);
      this.$nextTick(() => {
        this.setChecked();
      });
    },
    // 选择员工
    async changeFn(usersAll) {
      // const users = usersAll.persons;
      const users = usersAll;
      this.teSelected = Object.values(this.selected);
      if (users && users.length > 0) {
        let listArry = [];
        users.forEach(e => {
          if (e && e.fullname) {
            listArry.push({
              id: e.id,
              fullname: e.fullname,
              isUser: true
            });
          }
        });
        let reArry = this.reduceFn([...listArry]);
        this.$emit('input', reArry);
        this.$emit('select', reArry);
        this.teData = reArry;
      } else {
        this.$emit('input', []);
        this.$emit('select', []);
        this.teData = [];
      }
    },
    // 数组根据ID去重
    reduceFn(arryData) {
      // return arryData;
      let obj = {};
      return arryData.reduce((item, next) => {
        obj[next.id] ? '' : (obj[next.id] = true && item.push(next || ''));
        return item;
      }, []);
    },
    // 跨机构选择
    changeOrg(org) {
      this.teSearch.targetOrgId = org.orgId; // 机构id
      this.selectOpition.checkWord = '';
      this.teSearch.deptId = ''; // 清空部门选项
      this.teType = this.type === -1 ? '0' : this.type; // 清除讲师已选类型
      this.levelVal = ''; // 清除已选讲师等级
      this.teSearch.levelId = '';
      this.getTeList(true);
      this.getLevelList();
    },
    // 选择部门
    nodeClick(a) {
      this.teSearch.deptId = a.id;
      this.selectOpition.checkWord = a.id ? a.name : '';
      this.$refs['selectPopover'].cancel();
      this.getTeList(true);
    },
    // 获取级别列表
    getLevelList() {
      this.query.orgId =
        this.noStrong && this.selectOrg ? this.teSearch.targetOrgId : ''; // 弱管理根据机构变化orgId,否则传''
      let api = this.groupLevel ? getGroupTeLevelList : getTeLevelList;
      api(this.groupLevel ? this.query : null).then(levelIds => {
        this.levelList = levelIds || [];
      });
    },
    // 选择级别
    changeLevel() {
      this.teSearch.levelId = this.levelVal === '-1' ? '' : this.levelVal;
      this.getTeList(true);
    }
  },
  watch: {
    teData(newval) {
      this.teDataUser = newval;
      if (this.isSingle && Object.prototype.toString.call(newval) === '[object Object]') {
        if (newval.id) {
          this.teDataUser = [newval];
        } else {
          this.teData = [];
        }
      }
    },
    activeName(newVal) {
      if (newVal && newVal === 'person') this.getTeList(true);
    },
    teaList() {
      this.renderCount++;
    },
    teCatalogSearch(val) {
      this.$refs.tree.filter(val);
    },
    value(v) {
      this.formatModel(v);
      this.setChecked();
    },
    user() {
      this.selectUser();
    }
  }
};
</script>
